<template>
    <nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top ">
        <div class="container-fluid">
            <div v-on:click="toggle" class="navbar-wrapper">
                <div class="navbar-minimize">
                    <button id="minimizeSidebar" class="btn btn-just-icon btn-white btn-fab btn-round">
                        <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
                        <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
                    </button>
                </div>
                <a class="navbar-brand" id="breadcrumb">Dashboard</a>
            </div>
            <button id="toggle-navigation" v-on:click="toggle" class="navbar-toggler">
                <span class="sr-only">Toggle navigation</span>
                <span class="navbar-toggler-icon icon-bar"></span>
                <span class="navbar-toggler-icon icon-bar"></span>
                <span class="navbar-toggler-icon icon-bar"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-end">
                <b-form class="navbar-form">
                    <span class="bmd-form-group">
                        <model-list-select 
                            class="form-control"
                            :list="branches"
                            v-model="branch"
                            option-value="id"
                            option-text="name"
                            placeholder="Escolha uma Loja">
                        </model-list-select>
                    </span>
                </b-form>
                <ul class="navbar-nav">
                    <b-nav-item-dropdown top v-show="notifications.length > 0">
                        <template slot="button-content">
                            <i class="material-icons">notifications</i>
                            <span class="notification mr-1">{{ notifications.length }}</span>
                        </template>
                        <b-dropdown-item v-for="notification in notifications" :key="notification.id" v-on:click="navegateTo(notification)">{{ notification.description }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown bottom>
                        <template slot="button-content">
                            {{ auth.name }} | {{ auth.email }} <i class="material-icons">person</i>
                            <p class="d-lg-none d-md-block">
                                Account
                            </p>
                        </template>
                        <b-dropdown-item :to="{name: 'profile.edit'}">Perfil</b-dropdown-item>
                        <b-dropdown-item :to="{name: 'logout'}">Sair</b-dropdown-item>
                    </b-nav-item-dropdown>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import ApiService from '@/services/api.service';
    import JwtService from '@/services/jwt.service';

    export default {
        computed: {
            auth(){
                    return this.$store.state.auth.user
            },
            branch: {
                get: function () {
                    return this.$store.state.auth.user.branch_id;
                },
                set: function (_newBranch) {
                    this.$store.commit('auth/changeBranch', _newBranch);
                    JwtService.setBranch(_newBranch);
                    
                    ApiService.setupHeaders();
                    
                    this.$root.$emit('changeBranch');
                }
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            notifications() {
                return this.$store.state.defaults.notifications;
            },
            qtdNotificacoes() {
                return 10;
            }
        },
        data() {
            return {
                user: {
                    branch_id: null
                }
            };
        },
        methods: {
            async getDataBranches() {
                var self = this;

                if (self.$store.state.defaults.branches.length == 0) {
                    self.$store.dispatch('defaults/branches');
                }
            },
            async getDataNotifications() {
                var self = this;

                self.$store.dispatch('defaults/notifications');
            },
            navegateTo(notification) {
                var self = this;

                self.$store.dispatch('defaults/readNotification', notification.id);
                const route = JSON.parse(notification.route);
                this.$router.push(route);
            },
            toggle(_evt) {
                this.$parent.toggle();
            }
        },
        mounted() {
            var self = this;

            self.toggle();

            self.user = self.$store.state.auth.user;

            self.getDataBranches();

            setInterval(() => self.getDataNotifications(), 5000);
        }
    };
</script>

<style scoped>
    .navbar.navbar-absolute{
        z-index: 10 !important;
    }
</style>